function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.41797 0H0.761719C0.341098 0 0 0.349844 0 0.78125V4.53125C0 4.96266 0.341098 5.3125 0.761719 5.3125H4.41797C4.83859 5.3125 5.17969 4.96266 5.17969 4.53125V0.78125C5.17969 0.349844 4.83859 0 4.41797 0ZM3.65625 3.75H1.52344V1.5625H3.65625V3.75Z",
  fill: "#1B1E31"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.41797 35H0.761719C0.341098 35 0 35.3498 0 35.7812V39.5312C0 39.9627 0.341098 40.3125 0.761719 40.3125H4.41797C4.83859 40.3125 5.17969 39.9627 5.17969 39.5312V35.7812C5.17969 35.3498 4.83859 35 4.41797 35ZM3.65625 38.75H1.52344V36.5625H3.65625V38.75Z",
  fill: "#1B1E31"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.418 0H34.7617C34.3411 0 34 0.349844 34 0.78125V4.53125C34 4.96266 34.3411 5.3125 34.7617 5.3125H38.418C38.8386 5.3125 39.1797 4.96266 39.1797 4.53125V0.78125C39.1797 0.349844 38.8386 0 38.418 0ZM37.6562 3.75H35.5234V1.5625H37.6562V3.75Z",
  fill: "#1B1E31"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.418 35H34.7617C34.3411 35 34 35.3498 34 35.7812V39.5312C34 39.9627 34.3411 40.3125 34.7617 40.3125H38.418C38.8386 40.3125 39.1797 39.9627 39.1797 39.5312V35.7812C39.1797 35.3498 38.8386 35 38.418 35ZM37.6562 38.75H35.5234V36.5625H37.6562V38.75Z",
  fill: "#1B1E31"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 2.5,
  x2: 34,
  y2: 2.5,
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 5,
  y1: 37.5,
  x2: 34,
  y2: 37.5,
  stroke: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 36.5,
  y1: 36,
  x2: 36.5,
  y2: 5,
  stroke: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 2.5,
  y1: 36,
  x2: 2.5,
  y2: 5,
  stroke: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_d_toolbar_final)",
  filter: "url(#filter0_d_toolbar_final)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5093 29.3691L19.4903 32.3329C19.6523 32.5745 20.0059 32.5784 20.1733 32.3405L22.2198 29.4216L17.5093 29.3691ZM20.114 6.99914C18.5514 6.98173 17.2717 8.23327 17.2543 9.79588L17.2358 11.4532L22.8923 11.5163L22.9108 9.85889C22.9282 8.2977 21.6759 7.01724 20.114 6.99914ZM17.2122 13.5744L17.0625 27.0086C17.0625 27.0086 17.7845 26.3095 18.4845 26.3173C19.1845 26.3251 19.8681 27.0399 19.8681 27.0399C19.8681 27.0399 20.6114 26.341 21.3128 26.3488C22.0142 26.3566 22.719 27.0716 22.719 27.0716L22.8687 13.6374L17.2122 13.5744Z",
  fill: "#1B1E31"
}));

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_toolbar_final",
  x: -1,
  y: 3,
  width: 41.939,
  height: 41.939,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_d_toolbar_final"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(3 19.7805) rotate(-44.3618)"
})));

var SvgToolbarFinalize = function SvgToolbarFinalize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToolbarFinalize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ToolbarFinalize.92711dbf.svg";
export { ForwardRef as ReactComponent };